<template>
    <div>
        <!--<div class="row">-->
            <!--<div class="col-md-6">-->
                <!--<div class="panel">-->
                    <div class="panel-content active">
                      <u>Feb 13, 2021</u>
                      <ol style="margin-left: 40px">
                        <li><strong>EN Servers Fixed</strong> An issue due to deprecation of Flash caused an issue which impacted EN Servers for the last 9 days. All Fixed.</li>
                      </ol>
                      <u>Jan 21, 2021</u>
                      <ol style="margin-left: 40px">
                        <li><strong>It's a Girl, Again!</strong> Founder of this site just had a healthy beautiful baby girl. Donate to her <router-link to="/donate">college fund here :)</router-link></li>
                      </ol>
                      <u>Sep 21, 2020</u>
                      <ol style="margin-left: 40px">
                        <li><strong>9/13 Weekly Report Fix in progress</strong> For some unknown reason, our scripts failed to snapshot fellowship/user scores on Sep 13.  I do have tournament scores.  I have approximated each score by the half way point between 9/6 and 9/20 for the week of 9/13 and added the tournament scores. Script is running now, expected to be done by 3pm ET</li>
                      </ol>
                      <u>Sep 17, 2020</u>
                      <ol style="margin-left: 40px">
                        <li><strong>"Realtime updates not available", 15 Avatars, Building Cfg, FAQ Revised!</strong> Some of you have been having intermittent issues getting fellowships to refresh and realtime updates not available issues trying to go to elvenarchitect - I *think* i may have found the cause. Also, I added 15+ avatars that were missing, updated the building config file, this should fix stats not calculating properly for some orgs.  Thanks to my <router-link to="/donate">donators!</router-link> </li>
                      </ol>
                      <u>Apr 24, 2020</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Server capacity doubled!</strong> Upgraded the server around 7pm ET. Hopefully, this holds up to the weekend traffic. Thanks for your patience. Thanks for to those who made <router-link to="/donate">donations.</router-link></li>
                      </ol>
                      <u>Apr 19, 2020</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Server is overloaded!</strong> Site performance is borderline unusable.  Database is completely overloaded.  I will have to upgrade the server sometime this week.  In the meantime, please let the pages load don't refresh a bunch as it only makes it worse.  Each page load causes a database query which is performed regardless of whether you allow the page to fully load. </li>
                      </ol>
                      <u>Nov 10, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>ElvenArchitect.com is temporarily down, event buildings added</strong> Been getting a lot of emails about elvenarchitect links returning a permission errors.  This is a known issue, thier service provider is having an outage and is impacting this feature. Also, updated the building database which is used to compute available population and such.  Refreshing your city will lead to correct numbers if you use newer event buildings. </li>
                      </ol>

                      <u>Oct 13, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Added 2 New Servers: it2, ru3</strong> Basic Weekly reports for these servers will be available starting next week (two weeks of data are needed before you can compute deltas). Some accolades require 4 weeks of data so full reports will take 4 weeks. Also, as per FAQ users are not imported until a score of at least 500 is achieved. Once 500 is obtained they get automatically added the following Sunday..</li>
                      </ol>

                      <u>Sep 23, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Added 3 New Servers: us8, de7, nl2</strong> Basic Weekly reports for these servers will be available starting next week (two weeks of data are needed before you can compute deltas). Some accolades require 4 weeks of data so full reports will take 4 weeks. Also, as per FAQ users are not imported until a score of at least 500 is achieved. Once 500 is obtained they get automatically added the following Sunday..</li>
                      </ol>

                      <u>July 14, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>ElvenArchitect Links Fixed</strong> Added support for newer elvenarchitect api. Loading city maps works again. Special thanks to Goran over at  ElvenArchitect.com for the amazing developer support.</li>
                      </ol>

                      <u>Jun 11, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Chest Avg, Some Missing Tournaments</strong> Chest Average was wrong due to missing marble tournament.  ES2 didn't have ranking from last week, US2 & DE3 missing tournaments for users from planks.
                        <li><strong>Money Used / Supplies Used Fixed</strong>. For a few months now, the amount of supplies and money consumed in the tables was reporting 0.  Once your city has been refreshed refreshed this number will no longer say 0.</li>
                        <li><strong>2 Missing Avatars</strong>. Likely some additionals still missing.</li>
                      </ol>

                      <u>Jun 11, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Weekly Chest Average Wrong</strong>. Due to some data issues where fellowship tournament scores weren't recorded properly everyones average is lower then it should be.  This is a known issue and sorry about the inconvenience..</li>
                      </ol>

                      <u>Apr 28, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Realtime updates restored (including BETA)</strong>. About 4 days ago, a change to the game broke ElvenStat's ability to fetch your latest citymaps in realtime (it also impacted tournament scores getting updated).
                          BETA has been without reliable realtime updates for at least 6 months... Pleased to announced that realtime updates are fixed for all servers. Tournaments snapshots were recorded properly for this week.  As was the weekly report (albeit later than usual).
                        </li>
                      </ol>
                      <u>March 10, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Constructs Guest Race Support</strong>. Members with > lvl 24 tier 3 manufactories weren't computing properly.  Added missing avatars, Also, updated last weeks tournament relic to elixir.
                        </li>
                      </ol>
                      <u>Feb 17, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Fix Boosts in Recruit Mode</strong>. In recruiting (an exclusive feature for contributors), the needed boosts were sometimes wrong if fellowship had users with high mountain hall boost percentages or collects per day.
                        </li>
                      </ol>
                      <u>Feb 12, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Weekly Report for 10th Fixed</strong>. Weekly Snapshots were recorded late sunday evening US time which was just after midnight UTC.
                        </li>
                      </ol>
                      <u>Jan 28, 2019</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Weekly Report for 27th Fixed</strong>. Weekly Snapshots weren't recorded properly.  At 10:50am PT they were kicked off.  Should be fixed by 11:50 PT. Sorry for inconvenience.
                        </li>
                      </ol>
                      <u>Dec 30, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Fixed Two Tournaments that were mislabeled</strong>. Tounament from Dec 8, was labeled scrolls changed it to crystal.  Tournament on user profiles from Dec 29, showed as crystal changed it to elixir.
                        </li>
                      </ol>
                      <u>Nov 24, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>ElvenArchitect Links fixed</strong> EA recently switched to secure https, we updated our integration to support it.  There was a 36 hour period the links weren't working.
                        </li>
                      </ol>
                      <u>Nov 11, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Updated building support.</strong> Fixes issues where cities with latest event buildings wouldn't calculate properly.
                        <li><strong>US3 weekly reports fixed.</strong>
                        </li>
                      </ol>
                      <u>Nov 5, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Fixed Tournament Stats for Weekly Report Nov. 4</strong> Tournament scores were showing up as 0.
                        <li><strong>Added <img src="/static/img/icons/rank2.png" width="18"> 'rank' to tournament charts</strong> when you mouse over a tournament in the bar charts on fellowship page, it now displays what rank your fellowship came in for that tournament.
                        </li>
                      </ol>
                      <u>Oct 30, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Tournament relic updated to elixir.</strong> Initially, tournament relic was recorded as crystal for tournament that ended on Oct. 27.
                        </li>
                      </ol>
                      <u>Oct 14, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Workaround in place for US6 (Sinya) and DE6 (Sinya) Reports Missing for Oct 7</strong>. Due to an issue score snapshots were not properly recorded on Oct 7 (for these two servers ONLY).  It's impossible to get the exact scores for a past date at this point, but to allow weekly reports to be useful, I have set the score for Oct 7 to be the midpoint of scores between Sep 30, and Oct 14. Tournament Scores for Oct 6, were not affected and are accurate.
                        </li>
                      </ol>
                      <u>Oct 8, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Weekly Report Fix In Progress</strong>. Reports for October 7th were glitched.  Fix in progress expect all servers to be fixed by 5pm UTC.
                        </li>
                      </ol>
                      <u>Sep 24, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Weekly Report Fixed</strong>. Reports for September 23 we're not generated properly initially.  They are now correct.
                        </li>
                      </ol>
                      <u>Sep 4, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Alumi Bugs Fixed</strong>. Fixed several bugs in production calculations: Tier 2 calculations were incorrect if > LVL 24, all event buildings added, fixed bug in empty tile calculation.
                          <li>Fixed issue where "Inactive" flags weren't displaying properly / were being "sticky" (always appearing after you visited one inactive player).
                        </li>
                      </ol>
                      <u>Aug 25, 2018</u>
                      <ol style="margin-left: 40px">
                        <li><strong>Alumi Reporting WIP</strong>. Currently working on some fixing some bugs in city stats such as population and good production numbers. Stay tuned for that early next week.  Server has been stable for one month since last infrastructure update.  Thanks to everyone who made a <router-link to="/donate">donation to cover ongoing costs.</router-link>
                        </li>
                      </ol>
                        <u>July 22, 2018</u>
                        <ol style="margin-left: 40px">
                          <li><strong>Updated Servers</strong>. This afternoon we added more RAM, CPU, and disk space. We hope this will resolve the recent instability. Thanks to everyone who made a <router-link to="/donate">donation.</router-link></li>
                        </ol>
                        <u>July 18, 2018</u>
                        <ol style="margin-left: 40px">
                          <li><strong>Growing Pains!</strong>. The last couple days the site has been unreliable. Our database server has been crashing and leaving behind little info to diagnose. If you aren't getting data to load, this is likely the cause.  It's not you... it's us. Sorry for the inconvenience. If you can, support the site's infrastructure with a <router-link to="/donate">donation.</router-link></li>
                        </ol>
                        <u>June 25, 2018</u>
                        <ol style="margin-left: 40px">
                          <li><strong>It's a GIRL</strong>. The creator of ElvenStats just had their first child! Please be patient with our delayed responses as we try and get some sleep between feeds :).</li>
                        </ol>
                        <u>June 18, 2018</u>
                        <ol style="margin-left: 40px">
                          <li>Fixed bug on Recruit (median wasn't calculated properly). Recruit is a feature available exclusively to <a href="/donate">contributors.</a></li>
                        </ol>
                        <u>May 22, 2018</u>
                        <ol style="margin-left: 40px">
                          <li>Improvements to Recruit/Find Fellowship functionality: Links fixed on Recruit, boost indicators work on both.</li>
                        </ol>
                        <u>May 1, 2018</u>
                        <ol style="margin-left: 40px">
                            <li><strong>NOTE: Pop/Culture Calculations are currently wrong, updates for v1.52 are not yet finished.</strong></li>
                        </ol>
                        <u>April 22, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>Weekly reports finished around 17:00 UTC, 1:00pm ET, Added FI1 server. ES2/TR1 importing </li>
                        </ol>
                        <u>April 19, 2018</u>
                        <ol style="margin-left: 40px">
                            <li><strong>BETA: Matchmaker "Find Compatible Fellowship" released to <router-link to="/donate">contributors.</router-link></strong></li>
                            <li>Users below minimum score threshold are now created upon "Refresh Member List".</li>
                            <li>isActive algorithm now also considers tournament history (before only score changes).</li>
                            <li>Numerous backend infrastructure improvements. Migrated to FontAwesome5 pro for page load speed improvement.</li>
                        </ol>
                        <u>April 12, 2018</u>
                        <ol style="margin-left: 40px">
                            <li><span style="color:red">
                                There will be scheduled downtime tonight between 2am-3am Eastern time (6am-7am UTC) for some database maintenance.
                                </span>Our infrastructure costs are rising. Database needs more ram and faster, larger disk.  Please consider making a donation if you can. <b>As an incentive, we will be
                                making the matchmaker features available exclusively to contributors for 1 month when it's released.</b>
                            </li>
                        </ol>
                        <u>April 10, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>ES Language finished (thanks @krak93)</li>
                        </ol>
                        <u>April 8, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>This week's snapshots have been processed</li>
                            <li>16:30 UTC: Fixed bug with fellowship add/remove button & saving member goods table saving.</li>
                        </ol>

                        <u>April 7, 2018</u>
                        <ol style="margin-left: 40px">
                            <li><strong>Fellowship Banner Images (thanks @thedarkboo for the code!)</strong></li>
                            <li>Color Coded Bar Charts based on tournament relic</li>
                            <li><strong>Added Fellowship Tournament History / Score History Charts to Fellowship page.</strong></li>
                            <li>Added Average Tourney Metric to Player Page.</li>
                            <li><strong>Added Average Chests Metric to Fellowship Page.</strong></li>
                            <li>Made Tier Charts Responsive (no more overlap at low resolutions)</li>
                            <li>Fixed issue where server name wasn't appearing in a few places.</li>
                            <li>Updates to RU, RO, PT, PL languages</li>
                            <li>Switched site to SSL, improved page load speed</li>
                        </ol>
                        <u>April 3, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>Revised boost percentage estimates - Crafted new estimates based on how 2000+ users have edited boosts percents! <router-link to="/faq#boost-percentages">See here for more</router-link> </li>
                            <li>Fixed issue where usernames were being truncated on Fellowship page.</li>
                            <li>Added Toggle for weekly reports to specify whether message should fit in one message or not.</li>
                            <li>Fixed issue where refreshing user after changing collections per day would display the default amount.</li>
                        </ol>
                        <u>April 2, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>Added player Race (elf vs. human) to the player pages</li>
                            <li>Fixed issue where usernames were being truncated on Fellowship page.</li>
                            <li>Added Toggle for weekly reports to specify whether message should fit in one message or not.</li>
                            <li>Fixed issue where refreshing user after changing collections per day would display the default amount.</li>
                        </ol>
                        <u>April 1, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>Resolved Flag issue</li>
                            <LI>Improved translations for de, dk, hu, fr, pl, nl, br, gr</li>
                            <li>4 New Servers: PL2, PL3, DE5, RO1</li>
                            <li>Removed toggles on Player page for Culture Min / Collections per day</li>
                        </ol>
                        <u>March 31, 2018</u>
                        <ol style="margin-left: 40px">
                            <li><img width=24 :src="`/static/img/flags/gr.png`"> <img width=24 :src="`/static/img/flags/br.png`">  Language added (Thanks @Outlaw Kid, @MoaMaca)</li>
                            <li>Romanian / Portuguese partially added. Updated IT & HU translations.</li>
                            <li>Fixed an issue with weekly reports displaying "Insufficient History".</li>
                        </ol>
                        <u>March 30, 2018</u>
                        <ol style="margin-left: 40px">
                            <li><img width=24 :src="`/static/img/flags/pl.png`"> Language added (Thanks @Hara)</li>
                            <li>CZ Languages now load</li>
                        </ol>
                        <u>March 29, 2018</u>
                        <ol style="margin-left: 40px">
                            <li><strong>Tournaments page improved, can now view stats for previous tournaments, and player rankings displayed as well</strong></li>
                            <li><img width=24 :src="`/static/img/flags/cs.png`"> Language added (Thanks @Ramik)</li>
                            <li>FR, NL, DK translations greatly improved.</li>
                            <li>Various localization improvements: Charts / Date Formats</li>
                        </ol>
                        <u>March 27, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>
                                <img width=24 :src="`/static/img/flags/de.png`">
                                <img width=24 :src="`/static/img/flags/dk.png`">
                                <img width=24 :src="`/static/img/flags/es.png`">
                                <img width=24 :src="`/static/img/flags/fr.png`">
                                <img width=24 :src="`/static/img/flags/hu.png`">
                                <img width=24 :src="`/static/img/flags/it.png`">
                                <img width=24 :src="`/static/img/flags/nl.png`">
                                <img width=24 :src="`/static/img/flags/ru.png`">
                                <img width=24 :src="`/static/img/flags/se.png`">
                                <img width=24 :src="`/static/img/flags/sk.png`">
                                <strong>Translations are making their debut! <i class="fas fa-rocket"></i></strong> It's been remarkable how quickly the community has stepped up! Still more to be done <a href="http://dev.elvenstats.com/translation-instructions" target="_blank">see here to contribute.</a></STRONG>
                            </li>
                            <li>Added a <elv-user-badges :player="{isFriend:true}"></elv-user-badges> badge to players that have helped with translations or made a donation.</li>
                            <li>Big thanks to heitz, gamafey, heroe, krak93, Друиды, fanusa, petrence, ladiesmen, ap25, lappen, and Tordhrano</li>
                            <li>Fixed issue where cities with Phoenix Cult buildings population/culture stats were incorrect</li>
                        </ol>
                        <u>March 25, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>This weeks weekly reports are up!</li>
                            <li><STRONG>ACTIVE crowdsourcing of language translation is underway! Still have: Italian (50%), Dutch, Norwegian, Swedish, Polish, Portuguese, Greek, and a few others. <a href="http://dev.elvenstats.com/translation-instructions" target="_blank">See here to help</a></STRONG></li>
                            <li>French, German, Russian have been translated fully (will appear here in a few days)!</li>
                            <li>Fixed issue in weekly reports related to personal records were displayed for inactive members</li>
                            <li>NEW Server: gr1</li>
                        </ol>
                        <u>March 22, 2018</u>
                        <ol style="margin-left: 40px">
                            <li><STRONG>Re-engineering the site to support translations this weekend.  Looking for volunteers for: Italian, Dutch, Norwegian, Swedish, Polish, Portuguese, and Russian. If interested, please contact me.</STRONG></li>
                            <li>Fixed bug where new users weren't being added on refresh</li>
                            <li>Fixed boosts on a few servers.
                            <li>Added City Coverage Table to Fellowships/Player Pages</li>
                        </ol>
                        <u>March 21, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>Improvements to Fellowship Member sync button, it now also refreshes users scores and roles.
                            <li>Supplies and Coin tables apply culture boost</li>
                        </ol>
                        <u>March 20, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>Improved tables for better display at lower resolutions.</li>
                            <li>Iconified Tables on Fellowship/Player pages.</li>
                            <li>Bug Fix: Culture Boost displayed 0 on Player Pages</li>
                        </ol>
                        <u>March 19, 2018</u>
                        <ol style="margin-left: 40px">
                            <li>Elven Architect links display date of city snapshot / Ability to refresh user on player page.</li>
                            <li>Greatly improved the speed of tournaments page.</li>
                        </ol>
                        <u>March 19, 2018</u>
                        <ol style="margin-left: 40px;">
                            <li> More weekly report enhancements / bug fixes.</li>
                            <li> Fixed bug with expansions displaying 5 less then it should.</li>
                        </ol>
                        <u>March 18, 2018</u>
                        <ol style="margin-left: 40px;">
                            <li> Fixed a bug in weekly reports which impact people in Europe/Asia having to do with timezone dependencies in report calculations.</li>
                            <li> Added 1 new servers: DE4 BR1 BR2</li>
                        </ol>
                        <u>March 17, 2018</u>: Couple big updates:
                        <ol style="margin-left: 40px;">
                            <li> Updated Boost Detection: Approximately 1.5% of users had the wrong boosts detected.  New algorithm uses city location instead of analyzing number of manufactories a user has. Big thanks to Arayla for writing the algorithm!</li>
                            <li> Automatically imports users with missing information (no need refresh users manually now) </li>
                            <li> Add/Remove Fellows button to force an update of your current fellowship members / remove old expired accounts.</li>
                            <li> Added 3 new servers: SK1 / RU1 / RU2</li>
                        </ol>
                        <u>March 15, 2018</u>: Everyone, thanks for the positive feedback on the site.  Been working hard fixing bugs, adding clarifications, supporting new servers, and chatting with you kind folks.
                        The site has gotten more traffic than we expected during our beta launch week and we're so honored. Thanks to all that have helped spread the word!
                        <b>Changes in the last 48 hours:</b>
                        <ol style="margin-left: 40px;">
                            <li> Added 8 new servers: EN2 / EN3 / SE1 / NO1 / DK1 / PT1 / CZ1 / CZ2 </li>
                            <li> Improved player selection (favors exact matches / more results / results don't hide the input).  If still having issues goto <router-link to="/changePlayer">this page</router-link></li>
                            <li> Fellowship Page: Cleaned up the tables and added tool tips and long winded explanations.</li>
                            <li> Bug fix with LVL 25 Mountain Halls not being detected.</li>
                            <li> Some progress towards a next generation boost detection algorithm to support you mavericks out there that like to produce non-boosted manufactories.</li>
                            <li> Privacy Policy added. </li>
                            <li> IE fixes </li>
                        </ol>

                    </div>
                </div>
            <!--</div>-->
        <!--</div>-->
    <!--</div>-->
</template>

<script>
    import ElvUserBadges from "@/components/ElvUserBadges";

    export default {
        components: {
            ElvUserBadges
        },
        name: "elv-release-notes",
        data() {
            return {
            }
        },
        computed:{
        },
    }
</script>

<style scoped>
    ol {
        font-size: 90%
    }

</style>



// WEBPACK FOOTER //
// src/components/ElvReleaseNotes.vue